import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert_title = _resolveComponent("v-alert-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_v_alert, {
      type: "warning",
      class: "my-2",
      style: {"white-space":"pre-line"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_alert_title, null, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" エラーが発生しました ", -1)
          ]))]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.data.message), 1)
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.data.alert]
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.data.snackbar,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.snackbar) = $event)),
      timeout: "10000"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "red",
          variant: "text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.data.snackbar = false))
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" 閉じる ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.data.message !== null && _ctx.data.message !== undefined ? _ctx.data.message : "エラーが発生しました") + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}